/* MartinezFIT — theme.js */
(function () {
  'use strict';

  /* ---------- Scroll reveal ---------- */
  const revealEls = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && revealEls.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach((el) => io.observe(el));
  } else {
    revealEls.forEach((el) => el.classList.add('is-visible'));
  }

  /* ---------- Sticky header shadow on scroll ---------- */
  const header = document.querySelector('[data-header]');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Mobile menu ---------- */
  const menu = document.querySelector('[data-mobile-menu]');
  const openBtn = document.querySelector('[data-mobile-menu-open]');
  const closeBtn = document.querySelector('[data-mobile-menu-close]');
  const setMenu = (open) => {
    if (!menu) return;
    menu.classList.toggle('is-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  };
  openBtn && openBtn.addEventListener('click', () => setMenu(true));
  closeBtn && closeBtn.addEventListener('click', () => setMenu(false));
  if (menu) {
    menu.querySelectorAll('a').forEach((a) => a.addEventListener('click', () => setMenu(false)));
  }
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') setMenu(false); });

  /* ---------- Marquee duplication for seamless loop ---------- */
  document.querySelectorAll('[data-marquee]').forEach((track) => {
    const children = Array.from(track.children);
    children.forEach((child) => track.appendChild(child.cloneNode(true)));
  });

  /* ---------- Showcase rail arrows ---------- */
  document.querySelectorAll('[data-showcase]').forEach((shc) => {
    const rail = shc.querySelector('[data-rail]');
    const prev = shc.querySelector('[data-prev]');
    const next = shc.querySelector('[data-next]');
    if (!rail) return;
    const step = () => Math.max(280, rail.clientWidth * 0.6);
    prev && prev.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
    next && next.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));
  });

  /* ---------- Product gallery thumbs ---------- */
  document.querySelectorAll('[data-product-gallery]').forEach((g) => {
    const main = g.querySelector('[data-main-image]');
    const thumbs = g.querySelectorAll('[data-thumb]');
    thumbs.forEach((t) => {
      t.addEventListener('click', () => {
        const src = t.getAttribute('data-src');
        const alt = t.getAttribute('data-alt') || '';
        if (main && src) {
          main.src = src;
          main.alt = alt;
        }
        thumbs.forEach((x) => x.classList.remove('is-active'));
        t.classList.add('is-active');
      });
    });
  });

  /* ---------- Quantity steppers ---------- */
  document.querySelectorAll('[data-qty]').forEach((qty) => {
    const input = qty.querySelector('input');
    const minus = qty.querySelector('[data-qty-minus]');
    const plus = qty.querySelector('[data-qty-plus]');
    const update = (delta) => {
      const min = parseInt(input.getAttribute('min') || '1', 10);
      const next = Math.max(min, (parseInt(input.value, 10) || min) + delta);
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };
    minus && minus.addEventListener('click', () => update(-1));
    plus && plus.addEventListener('click', () => update(1));
  });

  /* ---------- Cart count refresh ---------- */
  const updateCartCount = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = String(count);
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  };
  window.MartinezFIT = window.MartinezFIT || {};
  window.MartinezFIT.refreshCart = async function () {
    try {
      const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const data = await r.json();
      updateCartCount(data.item_count || 0);
    } catch (_) { /* noop */ }
  };

  /* ---------- AJAX add-to-cart (graceful fallback to form submit) ---------- */
  document.querySelectorAll('form[action$="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      if (form.dataset.ajax === 'false') return;
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const originalText = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      try {
        const r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        });
        if (!r.ok) throw new Error('add failed');
        await window.MartinezFIT.refreshCart();
        if (btn) {
          btn.textContent = '✓ Added';
          setTimeout(() => { btn.textContent = originalText; btn.disabled = false; }, 1400);
        }
        window.location.href = '/cart';
      } catch (_) {
        if (btn) { btn.textContent = originalText; btn.disabled = false; }
        form.dataset.ajax = 'false';
        form.submit();
      }
    });
  });

  /* ---------- Init ---------- */
  if (window.MartinezFIT.refreshCart) window.MartinezFIT.refreshCart();
})();
